// ToggleSwitch.js
import React, { useState, useEffect } from 'react';
import { Switch } from '@mantine/core';

const ToggleSwitch = ({ isOn, onToggle }) => {
  const [isToggled, setIsToggled] = useState(isOn);

  useEffect(() => {
    setIsToggled(isOn);
  }, [isOn]);

  const handleToggle = () => {
    setIsToggled(!isToggled);
    onToggle(!isToggled);
  };

  return (
    <Switch
      checked={isToggled}
      onChange={handleToggle}
      size="md"
    />
  );
};

export default ToggleSwitch;
